"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const INITIAL_VALUE = -1;
function useMonotonicId(dependency) {
    const [id, setId] = react_1.useState(INITIAL_VALUE);
    react_1.useLayoutEffect(() => setId(prevId => prevId + 1), [dependency]);
    return id;
}
exports.default = useMonotonicId;
